import React from "react";
import styled from "styled-components";
import { FiTruck, FiClock, FiCreditCard } from "react-icons/fi";
import { BiMailSend } from "react-icons/bi";
import { FaInstagram } from "react-icons/fa";

import MainContainer from "../components/MainContainer";
import Reveal from "../components/utils/Reveal";

const DeliveryPage = () => {
  return (
    <MainContainer offCenter hideLogo>
      <Head>
        <Kicker>改善 Obsessed — informacije</Kicker>
        <Title>
          Dostava <span>配送</span>
        </Title>
      </Head>

      <Wrap>
        <Reveal>
          <Highlights>
            <Highlight>
              <FiClock />
              <b>Do 2 radna dana</b>
              <span>Poručeno do 12h šaljemo istog dana</span>
            </Highlight>
            <Highlight>
              <FiTruck />
              <b>Besplatna dostava</b>
              <span>Za sve porudžbine preko 7.000 RSD</span>
            </Highlight>
            <Highlight>
              <FiCreditCard />
              <b>Plaćanje pouzećem</b>
              <span>Bez avansnih uplata i bez rizika</span>
            </Highlight>
          </Highlights>
        </Reveal>

        <Grid>
          <Reveal>
            <Card>
              <h3>Način dostave</h3>
              <p>
                Sarađujemo sa najpouzdanijima — sve porudžbine šaljemo putem
                kurirske službe <strong>Pošta Srbije – Post Express</strong>.
              </p>
            </Card>
          </Reveal>

          <Reveal delay={0.06}>
            <Card>
              <h3>Šta se dešava sa paketom?</h3>
              <ul>
                <li>Poručeno do 12h — paket šaljemo istog dana.</li>
                <li>Poručeno posle 12h — šaljemo narednog radnog dana.</li>
                <li>Porudžbina stiže u roku od najviše 2 radna dana.</li>
              </ul>
            </Card>
          </Reveal>

          <Reveal delay={0.12}>
            <Card>
              <h3>Cena dostave</h3>
              <p>
                Cena zavisi od težine pošiljke — u proseku{" "}
                <strong>500–650 RSD</strong> za većinu paketa. Preko{" "}
                <strong>7.000 RSD dostava je besplatna</strong>.
              </p>
            </Card>
          </Reveal>

          <Reveal>
            <Card>
              <h3>Šta ako niste kod kuće?</h3>
              <p>
                Ako kurir ne uspe da vas pronađe, dobićete poruku, a paket će
                biti ostavljen u najbližem poštanskom centru za preuzimanje.
              </p>
            </Card>
          </Reveal>

          <Reveal delay={0.06}>
            <Card>
              <h3>Lično preuzimanje</h3>
              <p>
                Da — moguće je lično preuzimanje u <strong>Novom Sadu</strong>.
                Kontaktiraj nas da se dogovorimo.
              </p>
            </Card>
          </Reveal>

          <Reveal delay={0.12}>
            <Card>
              <h3>Reklamacije i povraćaj</h3>
              <ul>
                <li>Kontaktiraj nas odmah po prijemu paketa.</li>
                <li>Trošak vraćanja proizvoda snosi kupac.</li>
                <li>Nakon pregleda biraš zamenu ili povraćaj novca.</li>
                <li>Povraćaj novca ide isključivo na tekući račun.</li>
              </ul>
            </Card>
          </Reveal>
        </Grid>

        <Reveal>
          <ContactCard>
            <div>
              <h3>Promena adrese ili porudžbine?</h3>
              <p>Kontaktiraj nas što pre — tu smo za tebe.</p>
            </div>
            <Links>
              <a href="mailto:info@obsessed.rs">
                <BiMailSend size={16} /> info@obsessed.rs
              </a>
              <a
                href="https://instagram.com/obsessed.rs"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram size={16} /> @obsessed.rs
              </a>
            </Links>
          </ContactCard>
        </Reveal>
      </Wrap>
    </MainContainer>
  );
};

export default DeliveryPage;

const Head = styled.div`
  width: 100%;
  max-width: 116rem;
  margin: 0 auto;
  padding: 2rem 2rem 3.4rem;
`;

const Kicker = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  font-size: 1.1rem;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: var(--red, #fe5f55);
  font-family: "Poppins-Medium";
  margin-bottom: 1.2rem;

  &::before {
    content: "";
    width: 3.4rem;
    height: 1px;
    background: var(--red, #fe5f55);
  }
`;

const Title = styled.h1`
  font-family: "Anton", sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: clamp(3.4rem, 5.4vw, 5.6rem);
  line-height: 1;
  letter-spacing: 0.01em;
  color: var(--text, #f4f2ee);

  span {
    font-family: var(--font-kanji);
    font-size: 0.5em;
    color: var(--red, #fe5f55);
    vertical-align: middle;
    margin-left: 1rem;
  }
`;

const Wrap = styled.div`
  width: 100%;
  max-width: 116rem;
  margin: 0 auto;
  padding: 0 2rem 4rem;
`;

const Highlights = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.6rem;
  margin-bottom: 1.6rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Highlight = styled.div`
  background: var(--bg2, #17171c);
  border: 1px solid rgba(254, 95, 85, 0.22);
  border-radius: 0.6rem;
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  svg {
    width: 2.2rem;
    height: 2.2rem;
    color: var(--red, #fe5f55);
    margin-bottom: 0.8rem;
  }

  b {
    font-family: "Anton", sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 1.8rem;
    color: var(--text, #f4f2ee);
  }

  span {
    font-size: 1.3rem;
    font-family: "Poppins-Regular";
    color: var(--muted, #8e8c94);
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.6rem;
  margin-bottom: 1.6rem;

  & > div {
    height: 100%;
  }

  @media (max-width: 1030px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: var(--bg1, #101013);
  border: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  border-radius: 0.6rem;
  padding: 2.4rem;
  height: 100%;

  h3 {
    font-family: "Anton", sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 1.7rem;
    color: var(--text, #f4f2ee);
    margin-bottom: 1.2rem;
    display: flex;
    align-items: center;
    gap: 1rem;

    &::before {
      content: "";
      width: 1.8rem;
      height: 1px;
      background: var(--red, #fe5f55);
      flex-shrink: 0;
    }
  }

  p,
  li {
    font-size: 1.35rem;
    font-family: "Poppins-Regular";
    color: var(--muted, #8e8c94);
    line-height: 1.7;
  }

  strong {
    font-family: "Poppins-SemiBold";
    color: var(--text, #f4f2ee);
  }

  ul {
    padding-left: 1.6rem;
    list-style: disc;

    li {
      margin-bottom: 0.5rem;

      &::marker {
        color: var(--red, #fe5f55);
      }
    }
  }
`;

const ContactCard = styled.div`
  background: var(--bg2, #17171c);
  border: 1px solid rgba(254, 95, 85, 0.22);
  border-radius: 0.6rem;
  padding: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;

  h3 {
    font-family: "Anton", sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 1.8rem;
    color: var(--text, #f4f2ee);
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1.3rem;
    font-family: "Poppins-Regular";
    color: var(--muted, #8e8c94);
  }
`;

const Links = styled.div`
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.2rem;
    letter-spacing: 0.06em;
    font-family: "Poppins-Medium";
    color: var(--red, #fe5f55);
    border: 1px solid rgba(254, 95, 85, 0.4);
    border-radius: 0.4rem;
    padding: 1rem 1.6rem;
    text-decoration: none;
    transition: all 0.25s var(--ease, ease);

    &:hover {
      background: var(--red, #fe5f55);
      color: var(--bg0, #0a0a0c);
    }
  }
`;
